/**
 * 查询 location url 参数
 */
export function queryStrings() {
    return getQueryByUrl(window.location.href);
}
/**
 * 查询具体参数值
 * @param key
 */
export function queryString(key) {
    return queryStrings()[key];
}
/**
 * get query by object
 * @param obj
 */
export function getQueryStrByObj(obj) {
    return Object.keys(obj)
        .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
    })
        .join('&');
}
/**
 * 根据URL获取参数
 * @param {string} url
 * @param {boolean} isNeedDecode
 */
export function getQueryByUrl(url, isNeedDecode) {
    if (isNeedDecode === void 0) { isNeedDecode = false; }
    if (!url) {
        return {};
    }
    if (isNeedDecode) {
        url = decodeURIComponent(url);
    }
    var sps = url.split('?');
    if (sps.length > 1) {
        var params = '?' + sps[1];
        var reg = /(?:^\?|&)(.*?)=(.*?)(?=&|$)/g;
        var temp = void 0;
        var args = {};
        while ((temp = reg.exec(params)) !== null) {
            args[temp[1]] = decodeURIComponent(temp[2]);
        }
        return args;
    }
    else {
        return {};
    }
}
/**
 * 获取 url origin ，去除 querys
 * @param url
 */
export function getOriginByUrl(url) {
    if (!url) {
        return '';
    }
    return url.split('?')[0];
}
/**
 * URL附加参数
 * @param url
 * @param querys
 */
export function urlAppendQuery(url, querys) {
    if (querys) {
        var beforeAppend = url.indexOf('?') > -1 ? '&' : '?';
        url += beforeAppend + getQueryStrByObj(querys);
    }
    return url;
}
export default {
    queryStrings: queryStrings,
    queryString: queryString,
    getQueryStrByObj: getQueryStrByObj,
    getQueryByUrl: getQueryByUrl,
    getOriginByUrl: getOriginByUrl,
    urlAppendQuery: urlAppendQuery
};
